'use client'

interface IframeBlockProps {
	url: string
	aspectRatioDesktop: string
	aspectRatioMobile: string
}

export default function IframeBlock({ url, aspectRatioDesktop, aspectRatioMobile }: IframeBlockProps) {
	return (
		<div className={`content-block content-block--iframe w-full px-site-margin my-4`}>
			<iframe className="iframe rounded-weak overflow-clip" src={url} />
			<style jsx>{`
				.iframe {
					width: 100%;
					aspect-ratio: ${aspectRatioDesktop};
				}

				@media (max-width: 1023px) {
					.iframe {
						aspect-ratio: ${aspectRatioMobile};
					}
				}
			`}</style>
		</div>
	)
}
